import { StyleSheet } from 'aphrodite';
import { backgroundAlt, borderOutline, charmGray, lightGray, titles, white } from '../../../../styles/colors';

export const styleSheet = StyleSheet.create({
	panel: {
		marginTop: 16,
	},
	container: {
		backgroundColor: white,
		borderRadius: 12,
		boxShadow: '0 4px 24px rgba(0, 0, 0, 0.15)',
		width: 360,
		overflow: 'hidden',
	},
	inputWrapper: {
		display: 'flex',
		alignItems: 'center',
		padding: '12px 16px',
		gap: 10,
		borderBottom: `1px solid ${lightGray}`,
	},
	searchIcon: {
		color: charmGray,
		flexShrink: 0,
	},
	input: {
		flex: 1,
		border: 'none',
		outline: 'none',
		fontSize: 14,
		backgroundColor: 'transparent',
		color: titles,
		'::placeholder': {
			color: charmGray,
		},
	},
	clearButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: 4,
		backgroundColor: 'transparent',
		border: 'none',
		borderRadius: 4,
		cursor: 'pointer',
		color: charmGray,
		':hover': {
			backgroundColor: lightGray,
			color: titles,
		},
	},
	results: {
		maxHeight: 280,
		overflowY: 'auto',
	},
	resultItem: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		padding: '10px 16px',
		gap: 10,
		backgroundColor: 'transparent',
		border: 'none',
		cursor: 'pointer',
		textAlign: 'left',
		':hover': {
			backgroundColor: lightGray,
		},
		':focus': {
			backgroundColor: lightGray,
			outline: 'none',
		},
	},
	colorIndicator: {
		width: 8,
		height: 8,
		borderRadius: '50%',
		flexShrink: 0,
	},
	resultTitle: {
		flex: 1,
		fontSize: 14,
		color: titles,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap',
	},
	resultType: {
		fontSize: 12,
		color: charmGray,
		flexShrink: 0,
	},
	noResults: {
		padding: '16px',
		textAlign: 'center',
		fontSize: 14,
		color: charmGray,
	},
	hint: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: '10px 16px',
		gap: 6,
		fontSize: 12,
		color: charmGray,
		borderTop: `1px solid ${lightGray}`,
		backgroundColor: backgroundAlt,
	},
	hintSeparator: {
		margin: '0 4px',
	},
	kbd: {
		display: 'inline-block',
		padding: '2px 6px',
		backgroundColor: white,
		border: `1px solid ${borderOutline}`,
		color: titles,
		borderRadius: 4,
		fontSize: 11,
		fontFamily: 'monospace',
		fontWeight: 500,
	},
});
